// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"4cfc47b2","174":"ff0623fb","311":"24cf7e13","354":"056375d9","378":"df8e847b","453":"4ea553a9","550":"48541d46","605":"5b43206e","725":"a2ae2194","741":"dfb0bc15","755":"6a6f5814","943":"c6d06997"}[chunkId] + ".chunk.js";
};